import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

const CarSelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const route = location?.state?.route;
  const serviceType = location?.state?.serviceType || 'oneway';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!route) {
      navigate('/route-selection');
    }
  }, [route, navigate]);

  const vehiclesByServiceType = {
    oneway: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Sedan',
      seats: 4,
      luggage: 3,
      price: 3500,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car with sleek design parked on city street'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Compact SUV',
      seats: 4,
      luggage: 4,
      price: 4200,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
      imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'MPV',
      seats: 6,
      luggage: 4,
      price: 4600,
      features: ['AC', 'Music System', 'GPS', 'Spacious'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      imageAlt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Premium MPV',
      seats: 6,
      luggage: 5,
      price: 5300,
      features: ['AC', 'Music System', 'GPS', 'Premium Interior'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png",
      imageAlt: 'Kia Carens premium MPV with modern styling and comfortable interiors'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Luxury MPV',
      seats: 6,
      luggage: 6,
      price: 6000,
      features: ['AC', 'Music System', 'GPS', 'Luxury Seats'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      imageAlt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
    },
    {
      id: 6,
      name: 'Innova Crysta 7+1',
      type: 'Luxury MPV',
      seats: 7,
      luggage: 6,
      price: 6300,
      features: ['AC', 'Music System', 'GPS', 'Extra Seating'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
      imageAlt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel'
    },
    {
      id: 7,
      name: 'Innova Hycross',
      type: 'Hybrid Luxury MPV',
      seats: 6,
      luggage: 5,
      price: 7400,
      features: ['AC', 'Music System', 'GPS', 'Hybrid Engine'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
      imageAlt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
    }],

    local: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Sedan',
      seats: 4,
      luggage: 3,
      price: 1800,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car with sleek design parked on city street'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Compact SUV',
      seats: 4,
      luggage: 4,
      price: 2200,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
      imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'MPV',
      seats: 6,
      luggage: 4,
      price: 2500,
      features: ['AC', 'Music System', 'GPS', 'Spacious'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      imageAlt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
    },
    {
      id: 4,
      name: 'Innova Crysta',
      type: 'Luxury MPV',
      seats: 6,
      luggage: 6,
      price: 3000,
      features: ['AC', 'Music System', 'GPS', 'Luxury Seats'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      imageAlt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
    }],

    roundtrip: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Sedan',
      seats: 4,
      luggage: 3,
      price: 5000,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car with sleek design parked on city street'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Compact SUV',
      seats: 4,
      luggage: 4,
      price: 6000,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
      imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'MPV',
      seats: 6,
      luggage: 4,
      price: 6500,
      features: ['AC', 'Music System', 'GPS', 'Spacious'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Premium MPV',
      seats: 6,
      luggage: 5,
      price: 7500,
      features: ['AC', 'Music System', 'GPS', 'Premium Interior'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png",
      imageAlt: 'Kia Carens premium MPV with modern styling and comfortable interiors'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Luxury MPV',
      seats: 6,
      luggage: 6,
      price: 8500,
      features: ['AC', 'Music System', 'GPS', 'Luxury Seats'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
      imageAlt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
    }],

    tour: [
    {
      id: 1,
      name: 'Maruti Dzire',
      type: 'Sedan',
      seats: 4,
      luggage: 3,
      price: 3500,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      imageAlt: 'White Maruti Dzire sedan car with sleek design parked on city street'
    },
    {
      id: 2,
      name: 'Brezza',
      type: 'Compact SUV',
      seats: 4,
      luggage: 4,
      price: 4200,
      features: ['AC', 'Music System', 'GPS'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
      imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design'
    },
    {
      id: 3,
      name: 'Maruti Ertiga',
      type: 'MPV',
      seats: 6,
      luggage: 4,
      price: 4800,
      features: ['AC', 'Music System', 'GPS', 'Spacious'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png",
      imageAlt: 'Maruti Ertiga MPV with spacious seating capacity parked outdoors'
    },
    {
      id: 4,
      name: 'Kia Carens',
      type: 'Premium MPV',
      seats: 6,
      luggage: 5,
      price: 5500,
      features: ['AC', 'Music System', 'GPS', 'Premium Interior'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png",
      imageAlt: 'Kia Carens premium MPV with modern styling and comfortable interiors'
    },
    {
      id: 5,
      name: 'Innova Crysta',
      type: 'Luxury MPV',
      seats: 6,
      luggage: 6,
      price: 6200,
      features: ['AC', 'Music System', 'GPS', 'Luxury Seats'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
      imageAlt: 'Toyota Innova Crysta luxury MPV in silver color with premium features'
    },
    {
      id: 6,
      name: 'Innova Hycross',
      type: 'Hybrid Luxury MPV',
      seats: 6,
      luggage: 5,
      price: 7400,
      features: ['AC', 'Music System', 'GPS', 'Hybrid Engine'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_144c4e8d9-1766473631173.png",
      imageAlt: 'Toyota Innova Hycross latest model with hybrid technology and premium comfort'
    }],

    tempo: [
    {
      id: 1,
      name: 'Tempo Traveller 12 Seater',
      type: 'Tempo Traveller',
      seats: 12,
      luggage: 10,
      price: 8500,
      features: ['AC', 'Music System', 'GPS', 'Spacious'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png",
      imageAlt: 'Tempo Traveller 12 seater vehicle for group travel'
    },
    {
      id: 2,
      name: 'Tempo Traveller 14 Seater',
      type: 'Tempo Traveller',
      seats: 14,
      luggage: 12,
      price: 9500,
      features: ['AC', 'Music System', 'GPS', 'Extra Space'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png",
      imageAlt: 'Tempo Traveller 14 seater vehicle for large group travel'
    },
    {
      id: 3,
      name: 'Tempo Traveller 17 Seater',
      type: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 10500,
      features: ['AC', 'Music System', 'GPS', 'Maximum Capacity'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10a91d818-1764720425845.png",
      imageAlt: 'Tempo Traveller 17 seater vehicle for maximum group capacity'
    }],

    urbania: [
    {
      id: 1,
      name: 'Force Urbania 13 Seater',
      type: 'Force Urbania',
      seats: 13,
      luggage: 10,
      price: 12000,
      features: ['AC', 'Music System', 'GPS', 'Luxury Interior', 'Premium Comfort'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 13 seater luxury vehicle with premium interiors'
    },
    {
      id: 2,
      name: 'Force Urbania 16 Seater',
      type: 'Force Urbania',
      seats: 16,
      luggage: 12,
      price: 13500,
      features: ['AC', 'Music System', 'GPS', 'Luxury Interior', 'Extra Space'],
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater luxury vehicle for large groups'
    }]

  };

  const vehicles = vehiclesByServiceType?.[serviceType] || vehiclesByServiceType?.oneway;

  const getServiceTypeLabel = () => {
    const labels = {
      oneway: 'One Way',
      local: 'Local',
      tour: 'Tour',
      roundtrip: 'Round Trip',
      tempo: 'Tempo Traveller',
      urbania: 'Force Urbania'
    };
    return labels?.[serviceType] || 'One Way';
  };

  const handleSelectCar = (vehicle) => {
    navigate('/car-details', {
      state: {
        route,
        vehicle
      }
    });
  };

  if (!route) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      
      <main className="flex-1 pt-16 lg:pt-20">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center">
              {route?.from} to {route?.to} {getServiceTypeLabel()} Taxi Services
            </h1>
            <p className="text-center text-white/90 mt-4 text-lg">Advait Tour and Travels</p>
          </div>
        </div>

        {/* Vehicle Selection Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="space-y-6">
            {vehicles?.map((vehicle) =>
            <div
              key={vehicle?.id}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 p-4 md:p-6 items-center">
                  {/* Car Image */}
                  <div className="md:col-span-2">
                    <div className="w-full h-24 md:h-28 flex items-center justify-center">
                      <Image
                      src={vehicle?.image}
                      alt={vehicle?.imageAlt}
                      className="w-full h-full object-contain" />

                    </div>
                  </div>

                  {/* Car Details */}
                  <div className="md:col-span-3">
                    <p className="text-xs text-gray-500 uppercase mb-1">Car Type</p>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{vehicle?.name}</h3>
                    <p className="text-sm text-gray-600 mt-1">{vehicle?.type}</p>
                  </div>

                  {/* Luggage */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Briefcase" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{vehicle?.luggage} Luggage</p>
                    </div>
                  </div>

                  {/* Seats */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Users" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{vehicle?.seats} Seats</p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="md:col-span-2 text-center md:text-right">
                    <p className="text-2xl md:text-3xl font-bold text-green-600">
                      ₹{vehicle?.price?.toLocaleString('en-IN')}/-
                    </p>
                    <p className="text-xs text-gray-500">Inc. of Taxes*</p>
                  </div>

                  {/* Book Button */}
                  <div className="md:col-span-1 flex justify-center md:justify-end">
                    <button
                    onClick={() => handleSelectCar(vehicle)}
                    className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold px-6 py-3 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap">

                      Book
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="bg-white py-12 md:py-16 border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                Why Choose Our Service?
              </h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-600 text-white rounded-full mb-4">
                  <Icon name="DollarSign" size={24} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Best Prices</h3>
                <p className="text-sm text-gray-600">Competitive rates with no hidden charges</p>
              </div>
              
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-green-50 to-green-100">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-green-600 text-white rounded-full mb-4">
                  <Icon name="Users" size={24} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Expert Drivers</h3>
                <p className="text-sm text-gray-600">Experienced and courteous drivers</p>
              </div>
              
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-purple-50 to-purple-100">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-purple-600 text-white rounded-full mb-4">
                  <Icon name="Car" size={24} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Clean Vehicles</h3>
                <p className="text-sm text-gray-600">Well-maintained and sanitized cars</p>
              </div>
              
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-orange-50 to-orange-100">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-orange-600 text-white rounded-full mb-4">
                  <Icon name="Clock" size={24} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">On-Time Service</h3>
                <p className="text-sm text-gray-600">Punctual pickup and drop services</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>);

};

export default CarSelection;